function initialState() {
  return {
   
    DealerOptInModalInfo: {
      showModal: false,
      data: null
    },
    
  };
}

const state = initialState();
const getters = {};

const actions = {
  async getDealerTouchpoints(context, accountPlatformId) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "get",
      "/api/admin/get_touchpoint_item_setting_dealer/{accountplatformid}".replace("{accountplatformid}", accountPlatformId)
    );
    return response && response.data  && response.data.data? response.data.data : null;
  },
  async saveDealerTouchpoints(context, data) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "/api/admin/save_touchpoint_item_setting_dealer/{accountplatformid}".replace("{accountplatformid}", data.platform), data.touchpoint
    );
    return response && response.data  && response.data.data? response.data.data : null;
  },
  async getSystemTouchpoints(context) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "get",
      "/api/admin/get_all_touchpoint_item_summary_system"
    );
    return response && response.data  && response.data.data? response.data.data : null;
  },
  async saveTouchpointItems(context, touchpoint) {
   let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "/api/admin/save_touchpoint_item",
      touchpoint.touchpointItems
    );
    return response && response.data ? response.data : null;
  },
  getTouchpointSettingsForPlatform(context, platformId) {
    return new Promise((resolve, reject) => {
      let requestPayload = {
        accountPlatformIds: [platformId]
      };
      context.getters.CxmApiClient.ProcessRequest(
        "POST",
        "/api/contact_touchpoint/settings/get",
        requestPayload
      )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp);
          else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  saveTouchpointSettingsForPlatform(context, requestPayload) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "POST",
        "/api/contact_touchpoint/settings/save",
        requestPayload
      )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp);
          else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  getTouchpointAutoCloseSettings(context, requestPayload) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "POST",
        "/api/contact_touchpoint/autoclosesetting",
        requestPayload
      )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp);
          else reject(resp);
        })
        .catch(err => {
          reject(err.response); 
        });
    });
  },
  saveTouchpointAutoCloseSettings(context, requestPayload) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "PUT",
        "/api/contact_touchpoint/autoclosesetting",
        requestPayload
      )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp);
          else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  async saveDealerOptInChanges(context, data) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "/api/admin/save_touchpoint_item_setting_system",
      data
    );
    return response && response.data  && response.data.successful? response.data.successful : null;
  },
async getDealersForOptIn(context, touchpointItemId) {
      let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "/api/admin/get_touchpoint_item_setting_system/{touchpointitemid}".replace("{touchpointitemid}", touchpointItemId)
    );
    return response && response.data  && response.data.data? response.data.data : null;
  },
  updateDealerOptInModal(context, data) {
    context.commit("updateDealerOptInModal", data);
  },


};

const mutations = {
   updateDealerOptInModal(state, data) {
    state.DealerOptInModalInfo = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/TouchpointSettings.js